import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import { getActionsApiBaseUrl } from '@/microApps/kit';
import buildOrganizationVisibleMicroAppsPath from '../helpers/buildOrganizationVisibleMicroAppsPath';
import buildOrganizationVisibleMicroAppsQueryKey from '../helpers/buildOrganizationVisibleMicroAppsQueryKey';
import type {
    OrganizationVisibleMicroAppsEnvelope,
    UseListOrganizationVisibleMicroAppsParams,
    UseListOrganizationVisibleMicroAppsResult,
} from '../types';

const useListOrganizationVisibleMicroApps = ({
    organizationId,
    isQueryEnabled,
}: UseListOrganizationVisibleMicroAppsParams): UseListOrganizationVisibleMicroAppsResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<OrganizationVisibleMicroAppsEnvelope>({
        pathname: buildOrganizationVisibleMicroAppsPath({ organizationId }),
        method: 'GET',
        server: getActionsApiBaseUrl(),
        key: buildOrganizationVisibleMicroAppsQueryKey({ organizationId }),
        queryOptions: {
            enabled: isQueryEnabled && organizationId.length > 0,
        },
    });

    return {
        apps: data?.data.apps ?? [],
        isLoadingApps: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useListOrganizationVisibleMicroApps;
